function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.5 18.7728V21.7501C22.5 22.4404 21.9403 23.0001 21.25 23.0001H12.5V27.0052C12.5 27.3983 12.2589 27.7535 11.8848 27.9148C11.5112 28.0733 11.0736 28.0076 10.7697 27.7451L0.343047 18.7398C0.125156 18.5506 0 18.2815 0 18.0001C0 17.7187 0.125156 17.4495 0.343047 17.2603L10.7697 8.25577C11.0737 7.99272 11.5112 7.92616 11.8848 8.08608C12.2589 8.246 12.5 8.60241 12.5 8.99428V13.0001L21.8091 17.6546C22.2327 17.8664 22.5 18.2991 22.5 18.7728ZM39.657 9.7603L29.2303 0.755221C28.9263 0.4928 28.4888 0.426862 28.1152 0.585534C27.7411 0.746706 27.5 1.10186 27.5 1.49499V5.50007H18.75C18.0597 5.50007 17.5 6.05975 17.5 6.75007V9.72733C17.5 10.201 17.7673 10.6337 18.1909 10.8455L27.5 15.5001V19.5064C27.5 19.897 27.7411 20.2535 28.1152 20.4146C28.4888 20.5733 28.9264 20.5074 29.2303 20.2437L39.657 11.2398C39.8748 11.0505 40 10.7814 40 10.5C40 10.2186 39.8748 9.94952 39.657 9.7603Z",
  fill: "#56CCF2"
});

var SvgTradeIcon = function SvgTradeIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTradeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trade-icon.f1011003.svg";
export { ForwardRef as ReactComponent };